module.exports = __webpack_public_path__ + "static/media/GitHubMark.74f522ba.png";